import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router-dom";

import "./assessment.css";
import { AssessmentPage } from "./components/AssessmentPage";

const queryClient = new QueryClient();

export function AssessmentApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="wren-assessment">
        <Routes>
          <Route path="love-receive/:token" element={<AssessmentPage />} />
        </Routes>
      </div>
    </QueryClientProvider>
  );
}
